import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import LinkableItemList from "~/modules/mapEditor/components/LinkableItemList";

import { EcologicalFunctionCard } from "../EcologicalFunctionCard";
import { MapEditorObservationPanelEcologicalFunctionFragment } from "../EcologicalFunctionCard/fragments.generated";

type LinkEcologicalFunctionTabProps = {
    createTo: (element: MapEditorObservationPanelEcologicalFunctionFragment) => string;
    elements: MapEditorObservationPanelEcologicalFunctionFragment[];
    onLinkClick: (ecologicalFunctionId: string) => void;
};

export default function LinkEcologicalFunctionTab({ createTo, elements, onLinkClick }: LinkEcologicalFunctionTabProps) {
    const { t } = useTranslation("mapEditor");

    return elements.length > 0 ? (
        <LinkableItemList
            clickable
            createTo={createTo}
            items={elements}
            renderCard={element => (
                <EcologicalFunctionCard
                    key={element.id}
                    ecologicalFunction={element}
                    isLinked={false}
                    onLinkClick={onLinkClick}
                />
            )}
        />
    ) : (
        <Typography>{t("ecologicalFunctionLinking.noLinkableFunctions")}</Typography>
    );
}
